import axiosInstance from "../../helpers/api";

export const Login = (formData) => {
  return axiosInstance.post(`/login`, formData);
};

export const Forgetpassword = (formData) => {
  return axiosInstance.post(`/forgot-password/request`, formData);
};

export const ForgetpasswordOtp = (formData) => {
  return axiosInstance.post(`/forgot-password/verify-otp`, formData);
};

export const Resetpassword = (formData) => {
  return axiosInstance.post(`/forgot-password/reset`, formData);
};
export const Logout = () => {
  return axiosInstance.post(`/logout`);
};

export const Register = (formData) => {
  return axiosInstance.post(`/register`, formData);
};

export const getOtpSetting = () => {
  return axiosInstance.get(`/get-otp-setting`);
};

export const Otp = (formData) => {
  return axiosInstance.post(`/check-otp`, formData);
};
export const ResendOtp = (formData) => {
  return axiosInstance.post(`/resend-otp`, formData);
};
export const userVoucher = (formData) => {
  //console.log(formData);
  return axiosInstance.post(`/students/users_payments`, formData?.formData);
};

export const getSystemGovernment = () => {
  //console.log(formData);
  return axiosInstance.get(`/governorates`);
};

export const getSystemRegion = (gov_id) => {
  console.log(gov_id);
  return axiosInstance.get(`/regions/governorate/${gov_id}`);
};

export const getSystemGrades = () => {
  //console.log(formData);
  return axiosInstance.get(`/grades`);
};

export const getSystemMajors = () => {
  //console.log(formData);
  return axiosInstance.get(`/majors`);
};
